/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Cancel_ConfirmInputs */

const cs_tasks_protocol_cancel_confirm = /** @type {(inputs: Tasks_Protocol_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit žádost o podpis? Signatáři už dokument nedokončí.`)
};

const en_tasks_protocol_cancel_confirm = /** @type {(inputs: Tasks_Protocol_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel this signing request? Signers will no longer be able to complete it.`)
};

/**
* | output |
* | --- |
* | "Cancel this signing request? Signers will no longer be able to complete it." |
*
* @param {Tasks_Protocol_Cancel_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_cancel_confirm = /** @type {((inputs?: Tasks_Protocol_Cancel_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Cancel_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_cancel_confirm(inputs)
	return cs_tasks_protocol_cancel_confirm(inputs)
});